var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100",attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"router-anim","enter-active-class":"animated fadeInDown","leave-active-class":"animated fadeOutUp"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }